import React from "react";
import ImageRenderer from "../../../../libraries/ReportGenerator/ImageRenderer";
import { dataFormatters } from "../../../../utils/dataFormatters";
import ImageArea from "../../../Common/ImageArea";

export const SFRTA_RecordofDisturbanceForRailAndTrackComponentsReportSestions = {
  weldsInfo: {
    heights: {
      header1: "auto",
    },
    minDataRowsCount: 10,
    columns: [
      {
        title: "Details",
        colSpan: 8,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "detail",
        dataClassName: "text-right pd-right-10px d-block",
      },
      {
        title: "Weld # 1",
        colSpan: 6,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "w1",
      },
      {
        title: "Weld # 2",
        colSpan: 6,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "w2",
      },
    ],
  },
  getWeldInfoData: (data) => {
    return [
      { detail: "Track Disturbance Reference Number", w1: data["w1.tdrn"], w2: data["w2.tdrn"] },
      { detail: "Mile Post", w1: data["w1.mp"], w2: data["w2.mp"] },
      { detail: "Weld Number", w1: data["w1.mnum"], w2: data["w2.mnum"] },
      { detail: "Date", w1: dataFormatters.dateFormatter(data["w1.date1"]), w2: dataFormatters.dateFormatter(data["w2.date1"]) },
      {
        detail: "Time Weld was Made",
        w1: dataFormatters.convert24HourFormattedTimeToAMPM(data["w1.twwm"]),
        w2: dataFormatters.convert24HourFormattedTimeToAMPM(data["w2.twwm"]),
      },
      { detail: "Track ID", w1: data["w1.tido"], w2: data["w2.tido"] },
      { detail: "Track Side", w1: data["w1.tside"], w2: data["w2.tside"] },
      { detail: "Rail Size", w1: data["w1.rsize"], w2: data["w2.rsize"] },
      { detail: "Weld Manufacture", w1: data["w1.wmanuf"], w2: data["w2.wmanuf"] },
      { detail: "Pre-Heat Type (OXY/AIR)", w1: data["w1.pheat"], w2: data["w2.pheat"] },
      { detail: "Weld Gap", w1: data["w1.wgap"], w2: data["w2.wgap"] },
      {
        detail: "XXXX - Time",
        w1: dataFormatters.convert24HourFormattedTimeToAMPM(data["w1.xtime"]),
        w2: dataFormatters.convert24HourFormattedTimeToAMPM(data["w2.xtime"]),
      },
      { detail: "Air - Rail Temperature", w1: data["w1.artemp"], w2: data["w2.artemp"] },
      { detail: "Welders", w1: data["w1.welder"], w2: data["w2.welder"] },
      {
        detail: "Scan",
        w1: data["photo1"] ? (
          <ImageArea path="applicationresources" imagesList={[{ imgName: data["photo1"] }]} imageHeight={"250px"} />
        ) : null,
        w2: data["photo2"] ? (
          <ImageArea path="applicationresources" imagesList={[{ imgName: data["photo2"] }]} imageHeight={"250px"} />
        ) : null,
      },
    ];
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/RecordofDisturbanceForRailAndTrackComponentsReport/SFRTA_RecordofDisturbanceForRailAndTrackComponentsReportSchema.js